import React from "react";

const logo = {
    src: "https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png",
    srcSet:
        "https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png",
    alt: "logo",
    link: "/",
};

const menuItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about-us' },
    { name: 'Services', href: '/services' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact Us', href: '/contacts' },
];

const socials = [
    { icon: "facebook-1", href: "https://www.facebook.com/AxiomThemes/" },
    { icon: "twitter-new", href: "https://twitter.com/ThemesAxiom" },
    { icon: "dribble-new", href: "https://dribbble.com/AxiomThemes" },
    { icon: "instagram", href: "https://www.instagram.com/axiom_themes/" },
];

const extraItems = [
    {
        title: "Have a Project?",
        link: "mailto:info@website.com",
        label: "info@website.com",
    },
    {
        title: "Want to Work With Us?",
        link: "/about/",
        label: "Send Brief",
    },
    {
        title: "Want to Buy Products?",
        link: "/shop/",
        label: "Go to Shop",
    },
];

const MobileMenu = ({ isOpen, onClose }) => {
    return (
        <div className={`menu_mobile menu_mobile_fullscreen scheme_dark opened  ${isOpen ? "visible opacity-100" : "hidden opacity-0"}`}>
            <div className="menu_mobile_inner with_widgets">
                {/* Header */}
                <div className="menu_mobile_header_wrap">
                    <a className="sc_layouts_logo" href={logo.link}>
                        <img
                            loading="lazy"
                            src={logo.src}
                            srcSet={logo.srcSet}
                            alt={logo.alt}
                            width={173}
                            height={53}
                        />
                    </a>
                    <button className="menu_mobile_close menu_button_close inited_click" onClick={onClose} style={{background:"#11170f"}}>
                        <span className="menu_button_close_text">Close</span>
                        <span className="menu_button_close_icon" />
                    </button>
                </div>

                {/* Content */}
                <div className="menu_mobile_content_wrap content_wrap">
                    <div className="menu_mobile_content_wrap_inner">
                        <nav className="menu_mobile_nav_area">
                            <ul id="mobile-menu_mobile_465177615" className="prepared">
                                {menuItems.map((item) => (
                                    <li id="mobile-menu-item-18273" key={item.title} className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18273 current-menu-ancestor current-menu-parent">
                                        <a href={item.href}>
                                            <span>{item.name}</span>
                                            {/* {item.links.length > 0 && <span className="open_child_menu" />} */}
                                        </a>
                                        {/* <ul className="sub-menu">
                    {item.links.map((link) =>
                      link.subLinks ? (
                        <li key={link.label} className="menu-item-has-children">
                          <a href="#">
                            <span>{link.label}</span>
                            <span className="open_child_menu" />
                          </a>
                          <ul className="sub-menu">
                            {link.subLinks.map((sub) => (
                              <li key={sub.label}>
                                <a href={sub.href}>
                                  <span>{sub.label}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ) : (
                        <li key={link.label}>
                          <a href={link.href}>
                            <span>{link.label}</span>
                          </a>
                        </li>
                      )
                    )}
                  </ul> */}
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                    {/* Socials */}
                    {/* <div className="socials_mobile flex gap-3 mt-4">
                        {socials.map((s) => (
                            <a
                                key={s.icon}
                                target="_blank"
                                rel="nofollow"
                                href={s.href}
                                className={`social_item social_item_${s.icon}`}
                            >
                                <span className={`icon-${s.icon}`} />
                            </a>
                        ))}
                    </div> */}
                </div>

                {/* Footer / Extra widgets */}
                {/* <div className="menu_mobile_widgets_area mt-6">
          {extraItems.map((x) => (
            <div key={x.title} className="extra_item mb-3">
              <h6>{x.title}</h6>
              <a href={x.link} className="underline_anim underline_do_hover">
                {x.label}
              </a>
            </div>
          ))}
        </div> */}
            </div>
        </div>
    );
};

export default MobileMenu;
